import { addBooleanParameter, addDefaultParameter } from "@ovh-ui/common/component-utils";

export default class {
    /* @ngInject */
    constructor ($attrs) {
        this.$attrs = $attrs;
    }

    $onInit () {
        // Guidelines default value for dismissable attribute
        addDefaultParameter(this, "dismissable", this.type === "info" || this.type === "success");
        addBooleanParameter(this, "dismissable");
    }

    dismiss () {
        this.dismissed = true;
        this.onDismissed();
    }
}
